export const footerTranslate = {
  es: {
    title: "Consulta las condiciones de nuestros beneficios adicionales",
    linkText: "Ver términos y condiciones",
    accept: "Aceptamos los siguientes métodos de pago",
    cc: "Tarjetas de crédito",
  },
  eng: {
    title: "Check the conditions of our additional benefits",
    linkText: "Terms and conditions",
    accept: "We accept the following payment methods",
    cc: "Credit Cards",
  },
};
